<template>
  <main>
    <router-view></router-view>
  </main>
</template>

<script setup>
import { useRoute, useRouter } from 'vue-router'
import { watchEffect, ref, provide, watch, computed } from 'vue'

const route = useRoute();
const router = useRouter();
const lastMainPath = ref('');

router.beforeEach((to, from, next) => {
  setTimeout(() => {
    document.title = to.meta.title || 'NO + TOC';
    next();
  }, 500)
  setTimeout(() => {
    window.scrollTo(0, 0);
  }, 1500)
});

function cambiarDescripcion(descripcion) {
  const metaDescription = document.querySelector('meta[name="description"]');
  if (metaDescription) {
    metaDescription.setAttribute("content", descripcion);
  } else {
    const head = document.head;
    const newMetaDescription = document.createElement("meta");
    newMetaDescription.setAttribute("name", "description");
    newMetaDescription.setAttribute("content", descripcion);
    head.appendChild(newMetaDescription);
  }
}
provide('cambiarDescripcion', cambiarDescripcion);
</script>
